import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-contexts-contexts-breadcrumb-card',
  templateUrl: './contexts-contexts-breadcrumb-card.component.html',
  styleUrls: ['./contexts-contexts-breadcrumb-card.component.scss']
})
export class ContextsContextsBreadcrumbCardComponent implements OnInit {

  @Input() contexts;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
    private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private contextsService: ContextsContextsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterContexts()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.contextsService.toggleContextsDisposition(viewDis);
  }

  public createContext() {
    this.router.navigate(['../context'], {relativeTo: this.activatedRoute.parent});
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.contextsService.searchContexts(event.target.value);
  }
}
